import { createFileRoute } from "@tanstack/react-router"

import { CreateLaneView } from "@/features/lanes/components/create-lane-view"
import { publicPlansQueryOptions } from "@/features/lanes/hooks/use-plans"
import { warm } from "@/lib/router/warm"

export const Route = createFileRoute("/_shell/voxlane/lanes/new")({
  // Awaited (bounded): the page paints with its data, not skeletons.
  loader: ({ context: { queryClient } }) =>
    warm(queryClient, [
      publicPlansQueryOptions(),
    ]),
  component: CreateLaneView,
})
